import React from 'react';
export default class Timer extends React.Component {
  state = { id: Number(new Date()) };
  timer;
  componentDidMount() {
    if (Date.parse(this.props.dateEnd)) {
      this.timer = setInterval(() => calculate(this.props.dateEnd, this.state.id), 1000);
    }
  }
  componentWillUnmount() {
    clearInterval(this.timer);
  }
  render() {
    const { id } = this.state;
    return (
      <span
        class="timer"
        style={
          this.props.home
            ? { color: this.props.color, fontWeight: 600 }
            : { color: this.props.color, fontWeight: 600 }
        }
      >
        <span id={`hours_${id}`} />
        <span id={`minutes_${id}`} />
        <span id={`seconds_${id}`} />
      </span>
    );
  }
}
function calculate(dateEnd, id) {
  var days, hours, minutes, seconds;
  var dateStart = new Date();
  var dateStart = new Date(
    dateStart.getUTCFullYear(),
    dateStart.getUTCMonth(),
    dateStart.getUTCDate(),
    dateStart.getUTCHours() - new Date().getTimezoneOffset() / 60,
    dateStart.getUTCMinutes(),
    dateStart.getUTCSeconds()
  );
  var timeRemaining = parseInt((dateEnd - dateStart.getTime()) / 1000);
  if (timeRemaining >= 0) {
    days = parseInt(timeRemaining / 86400);
    timeRemaining = timeRemaining % 86400;
    hours = parseInt(timeRemaining / 3600);
    timeRemaining = timeRemaining % 3600;
    minutes = parseInt(timeRemaining / 60);
    timeRemaining = timeRemaining % 60;
    seconds = parseInt(timeRemaining);
    //   document.getElementById(`days_${id}`).innerHTML = parseInt(days, 10);
    if (hours < 10) {
      document.getElementById(`hours_${id}`).innerHTML = (
        '0' +
        hours +
        'h '
      ).slice(-3);
    } else {
      document.getElementById(`hours_${id}`).innerHTML = (
        '0' +
        hours +
        'h '
      ).slice(-4);
    }
    document.getElementById(`minutes_${id}`).innerHTML = (
      '0' +
      minutes +
      'm '
    ).slice(-4);
    document.getElementById(`seconds_${id}`).innerHTML = (
      '0' +
      seconds +
      's'
    ).slice(-3);
  } else {
    return;
  }
}

function countDown(dateEnd, id, clearTimer) {
  var timer;
  dateEnd = new Date(dateEnd);
  dateEnd = dateEnd.getTime();
  if (isNaN(dateEnd)) {
    return;
  }
  if (clearTimer) {
    clearTimer(timer);
  } else {
    timer = setInterval(() => calculate(dateEnd, id), 1000);
  }
}
